import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RouteConstant } from '../_constants/route.constant';
import { LocalStorageProvider } from '../_services/common/storage.service';
import { AuthService } from '../_services/pages/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService, private storageService: LocalStorageProvider) { }
  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    // let token = this.storageService.getItem('token');
    let cUser = this.storageService.getItem('CurrentUser');
    if (cUser) {
      if (this.authService.isLoggedIn) {
        return true;
      }
      this.storageService.clearAll()
      this.router.navigate(['/'])
      return false;
    }
    else {
      this.storageService.clearAll()
      this.router.navigate(['/'])
      return false;
    }

    // if (this.authService.isLoggedIn && token != undefined && token != null && cUser != undefined && cUser != null ) {
    //   return true;
    // }
    // this.router.navigate(['/'])
    // return false;
  }
}

@Injectable()
export class CanLoginActivate implements CanActivate {
  constructor(private router: Router, private service: AuthService, private storageService: LocalStorageProvider) { }

  canActivate() {

    if (!this.service.isLoggedIn) {
      return true;
    } else {
      let cUser = this.storageService.getItem('CurrentUser');
      if (cUser) {
        this.router.navigate([`${RouteConstant.Dashboard}`]);
        return false;
      }
      else{
        this.storageService.clearAll();
        return true; 
      }
    }
  }
}
